export const KeyboardIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="14"
    fill="none"
    viewBox="0 0 20 14"
    {...props}
  >
    <path
      fill="#7D8291"
      d="M16.667.125a2.71 2.71 0 0 1 2.708 2.708v8.334a2.71 2.71 0 0 1-2.708 2.708H3.333a2.71 2.71 0 0 1-2.708-2.708V2.833A2.71 2.71 0 0 1 3.333.125zM3.333 1.375c-.805 0-1.458.653-1.458 1.458v8.334c0 .805.653 1.458 1.458 1.458h13.334c.805 0 1.458-.653 1.458-1.458V2.833c0-.805-.653-1.458-1.458-1.458zm10.959 8.138a.625.625 0 0 1 0 1.224l-.126.013H5.833a.625.625 0 0 1 0-1.25h8.333zM4.918 6.909a.626.626 0 0 1 0 1.225l-.126.012H3.75a.626.626 0 0 1 0-1.25h1.042zm3.645 0a.626.626 0 0 1 0 1.225l-.126.012H7.397a.626.626 0 0 1 0-1.25h1.042zm3.647 0a.626.626 0 0 1 0 1.225l-.126.012h-1.042a.626.626 0 0 1 0-1.25h1.042zm3.645 0a.626.626 0 0 1 0 1.225l-.126.012h-1.041a.626.626 0 0 1 0-1.25h1.041zM4.919 4.305a.626.626 0 0 1 0 1.224l-.126.013H3.75a.625.625 0 0 1 0-1.25h1.042zm3.645 0a.626.626 0 0 1 0 1.224l-.126.013H7.397a.626.626 0 0 1 0-1.25h1.042zm3.647 0a.626.626 0 0 1 0 1.224l-.126.013h-1.042a.625.625 0 0 1 0-1.25h1.042zm3.645 0a.626.626 0 0 1 0 1.224l-.126.013h-1.041a.625.625 0 0 1 0-1.25h1.041z"
    ></path>
  </svg>
);
